var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "input grid__cell",
      class: [_vm.inputClasses]
    },
    [
      _c(
        "div",
        {
          staticClass: "input--text input--text-numbers",
          class: { "right-padding": _vm.removeIcon }
        },
        [
          _c(
            "div",
            { staticClass: "input-top mg mg--b-2" },
            [
              _c("p", { staticClass: "title-input text-small blueDark" }, [
                _vm._v(" " + _vm._s(_vm.$t(_vm.literal)))
              ]),
              _vm.showTooltip
                ? _c("ma-tooltip", { attrs: { textInfo: _vm.textTooltip } })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "input__wrapper" }, [
            _c("input", {
              attrs: {
                id: "inputNumber",
                name: _vm.name,
                type: _vm.type,
                disabled: _vm.disabled,
                autocomplete: _vm.autocomplete
              },
              domProps: { value: _vm.value },
              on: {
                change: function($event) {
                  return _vm.$emit("change", $event.target.value)
                },
                input: function($event) {
                  return _vm.$emit("input", $event.target.value)
                }
              }
            }),
            _c(
              "span",
              { staticClass: "input__icon" },
              [
                _c("svgicon", {
                  attrs: { icon: _vm.icon, height: "18", color: "#FFFFFF" }
                })
              ],
              1
            )
          ]),
          _vm.name === "DAMAGE_SURFACE"
            ? _c(
                "div",
                { staticClass: "input--text input__area mg mg--t-2" },
                [
                  _c("svgicon", {
                    attrs: { icon: "Info", height: "14", color: "#C5CACF" }
                  }),
                  _c("p", { staticClass: "title-input text-small" }, [
                    _vm._v(_vm._s(_vm.$t("areaMeasurement.measurementTipe")))
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertIsVisible,
              expression: "alertIsVisible"
            }
          ],
          staticClass: "input__alerts"
        },
        [
          _c(
            "div",
            { staticClass: "input__icon" },
            [_c("svgicon", { attrs: { name: "alert-circle" } })],
            1
          ),
          _c("div", { staticClass: "input__alerts__wrapper" }, [
            _c(
              "div",
              _vm._l(_vm.validationErrors, function(error) {
                return _c("p", { staticClass: "input__alerts__text" }, [
                  _vm._v(_vm._s(error.description))
                ])
              }),
              0
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }